import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RestaurantPreloader',
  props: {
  code: {
    type: String,
    required: true,
    default: ''
  }
},
  setup(__props) {

const props = __props



// Решаем один раз при рендере: код, пришедший позже, не подменяет анимацию на ходу
const showRestaurantLoader = Boolean(props.code)

const getImgUrl = computed(() => `${process.env.IMG_URL}/loader/${props.code}.gif`)

return { __sfc: true,props, showRestaurantLoader, getImgUrl }
}

})